import {
  Avatar,
  Box,
  Button,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Toolbar,
} from "@mui/material";
import { AppBar } from "@mui/material";
import logo from "../../assets/images/logo.png";
import styles from "./Header.module.scss";
import { useContext, useState } from "react";
import MainContext from "../../context/mainContext";
import { useTranslation } from "react-i18next";
import Notifications from "../../pages/notifications";
import { useNavigate } from "react-router";

interface NavItem {
  title: string;
  url: string;
  target: string;
}

const Header: React.FC = () => {
  const navItems: NavItem[] = [
    { title: "Home", url: "/", target: "_self" },
    {
      title: "Publication Guides",
      url: "https://idbg.sharepoint.com/sites/IDBInvestPublicationHub/SitePages/publication-Guides.aspx",
      target: "_blank",
    },
    {
      title: "Communication Guides",
      url: "https://idbg.sharepoint.com/sites/IDBInvestPublicationHub/SitePages/communication-guides.aspx",
      target: "_blank",
    },
    {
      title: "FAQs",
      url: "https://idbg.sharepoint.com/sites/IDBInvestPublicationHub/SitePages/FAQs.aspx",
      target: "_blank",
    },
    {
      title: "IDB Invest Publications",
      url: "https://www.idbinvest.org/en/publications",
      target: "_blank",
    },
    {
      title: "Knowledge Engine",
      url: "https://idbg.sharepoint.com/sites/knowledge",
      target: "_blank",
    },
  ];

  const { currentUser } = useContext(MainContext);
  const navigate = useNavigate();

  const { t } = useTranslation();

  const [accountMenuAnchorEl, setAccountMenuAnchorEl] =
    useState<null | HTMLElement>(null);
  const accountMenuOpen = Boolean(accountMenuAnchorEl);

  const handleMyPublicationsClick = () => {
    navigate("myInbox");
  };

  const handleMyTasksClick = () => {
    navigate("myTasks");
  };

  const handleAdminClick = () => {
    navigate("admin");
  };

  const firstLetter = (text: string) => {
    return text && text.length > 0 ? text[0] : "";
  };

  return (
    <AppBar component="nav" className={styles.header}>
      <Toolbar>
        <div className={styles.logo}>
          <Link href="/">
            <img src={logo} alt="IDB Invest" />
          </Link>
        </div>
        <Box className={styles.pageLinks}>
          {navItems.map((item) => (
            <Button key={item.title} href={item.url} target={item.target}>
              {item.title}
            </Button>
          ))}
        </Box>
        {currentUser && (
          <>
            <Box className={styles.userItems}>
              <Notifications />
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-haspopup="true"
                color="primary"
                className={styles.currentUser}
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  setAccountMenuAnchorEl(event.currentTarget);
                }}
              >
                <Avatar>{`${firstLetter(currentUser.lastName)}${firstLetter(
                  currentUser.firstName
                )}`}</Avatar>
                <div className={styles.name}>{currentUser.displayName}</div>
              </IconButton>
            </Box>
            <Menu
              anchorEl={accountMenuAnchorEl}
              className={styles.userMenu}
              id="account-menu"
              open={accountMenuOpen}
              onClose={() => setAccountMenuAnchorEl(null)}
              onClick={() => setAccountMenuAnchorEl(null)}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem onClick={handleMyPublicationsClick}>
                {t("myPublications")}
              </MenuItem>
              <MenuItem onClick={handleMyTasksClick}>{t("myTasks")}</MenuItem>
              {currentUser.isAdmin ? (
                <MenuItem onClick={handleAdminClick}>{t("admin")}</MenuItem>
              ) : (
                <div key="" />
              )}
            </Menu>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
